import { IEntregaNoCd } from '../../../../../store/ducks/entregaNoCd/types';
import mask from '../../../../../utils/mask';

interface ExportBtnProps {
  'Ordem de carga': number;
  'Status ': string;
  'Nome da transportadora': string;
  'Peso ': string;
  'Valor ': string;
  'Placa ': string;
  'Tipo de veículo': string;
  'Nome do motorista': string;
  'CPF do motorista': string;
  'Tipo de assoalho': string;
  'Nome do destinátario': string;
}

export const exportDataEntregaNoCd = (entregas: IEntregaNoCd[]): ExportBtnProps[] =>
  entregas?.map((item) => {
    let status;
    switch (item.status) {
      case 'AGA':
        status = 'Aguardando agendamento';
        break;
      case 'AGE':
        status = 'Agendado';
        break;
      case 'EXP':
        status = 'Expedido';
        break;
      default:
        status = '';
        break;
    }
    return {
      'Ordem de carga': item.ordemCarga,
      'Status ': status,
      'Nome da transportadora': item.nomeTransportadora,
      'Peso ': mask('peso', item.peso),
      'Valor ': mask('currency', item.valor),
      'Placa ': item.placa,
      'Tipo de veículo': item.tipoVeiculo,
      'Nome do motorista': item.nomeMotorista,
      'CPF do motorista': item.cpfMotorista,
      'Tipo de assoalho': item.assoalho
        ? item.assoalho === 'M'
          ? 'Madeira'
          : 'Ferro'
        : 'Não informado',
      'Nome do destinátario': item.nomeDestinatario,
    };
  });
